<!--//证书预览 -->
<template>
  <div id="pdfDetail" class="pdfDetail">
    <el-dialog
      :visible="pdfDialogVisible"
      :title="titleName"
      @close="closeDialog"
      :width="`${dialogWidth}px`"
      :show-close="showClose"
      id="pdfDialog"
    >
      <!-- <div @click="downloadPdf" class="download">下载</div> -->
      <el-button type="primary" @click="downloadPdf" class="download">下载</el-button>
      <el-button @click="closeDialog" class="download-close-button">关闭</el-button>
      <div>
        <pdf :src="src"></pdf>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import pdf from 'vue-pdf';
import { saveAs as FileSaver } from 'file-saver';
export default {
  props: {
    pdfDialogVisible: {
      type: Boolean,
      default: false,
    },
    pdfRow: {},
    titleName: { //标题
      type: String,
      default() {
        return '证书预览';
      },
    },
    showClose: { //是否展示关闭按钮
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      src: '',
      dialogWidth: 840,
    };
  },
  components: { pdf },
  //方法集合
  methods: {
    getTotal() {
      this.src = this.pdfRow;
      // this.src = 'https://oss-cn-north-1.unicloudsrv.com/unicloudexport1/license/authorize/1736312421810/UNICLOUDOS-SV-1Y%E6%8E%88%E6%9D%83%E4%B9%A6-20250108130021703.pdf';
      this.src = pdf.createLoadingTask(this.src);
    },
    downloadPdf() {
      if (this.pdfRow) {
        let temp = this.pdfRow.split('/');
        let name = temp[temp.length - 1];
        name = decodeURI(name);
        const ajax = new XMLHttpRequest();
        ajax.open('GET', this.pdfRow, true);
        ajax.responseType = 'blob';
        ajax.onload = function () {
          const file = new Blob([ajax.response], { type: 'blob' });
          FileSaver.saveAs(file, name);
        };
        ajax.send();
      }
    },
    closeDialog() {
      this.$emit('closeDialog', false);
    },
  },
  mounted() {
    this.dialogWidth = 840;
    this.getTotal();
  },
};
</script>
<style lang="less" scoped>
.download {
  float: right;
  color: #fff;
  position: relative;
  z-index: 200;
  margin-right: 10px;
}
.download:hover {
  cursor: pointer;
}
.pdfDetail /deep/ .el-dialog__body {
  padding: 0 15px 30px;
}
.download-close-button {
  float: right;
  border: 1px solid #B707AB;
  color: #B707AB;
  position: relative;
  z-index: 200;
  margin-right: 20px;
}
</style>
